module.exports = __webpack_public_path__ + "static/img/Presentation.b5e2c871.png";